<template>
    <div id="app" @click="onBodyClick">
        <v-head :flag="flag"></v-head>
        <div class="content">
            <router-view class="router-view"></router-view>
            <v-foot></v-foot>
        </div>
        <div class="scroll-to-top" v-if="showScrollToTop" @click="toTop"></div>
    </div>
</template>

<script>
    import vHead from './Head.vue'
    import vFoot from './Foot.vue'
	export default {
        components: {
            vHead,
            vFoot,
        },
        data(){
            return {
                flag: false,
                showScrollToTop: false,
            }
        },
        methods: {
            onBodyClick: function(){
                this.flag = ! this.flag
            },
            toTop: function(){
                window.scrollTo(0, 0)
            },
            handleScroll (event) {
                if(this.showScrollToTop) {
                    if(window.pageYOffset <= 10) {
                        this.showScrollToTop = false
                    } 
                } else {
                    if(window.pageYOffset > 10) {
                        this.showScrollToTop = true
                    }
                }
            }
        },
        created () {
			window.addEventListener('scroll', this.handleScroll);
		},
		destroyed () {
			window.removeEventListener('scroll', this.handleScroll);
        },
	};
</script>

<style scoped>
    
</style>
